import { Component } from "react";
import PropTypes from "prop-types";
import "./SingleRangeSlider.scss";

const propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
};

class SingleRangeSlider extends Component {
  constructor(props) {
    super(props);
    const { min, max, value } = this.props;
    const total = max - min + 1;
    const newValue = value / total;
    this.state = {
      newValue,
    };
  }
  getMousePosition = (e) => {
    const trackRect = this.track.getBoundingClientRect();
    const x = (e.clientX - trackRect.left) / trackRect.width;
    return x;
  };

  onMouseDown = (e, which) => {
    window.addEventListener("mousemove", this.onMouseMove);
    window.addEventListener("mouseup", this.onMouseUp);
    this.setState({ which });
  };

  onMouseMove = (e) => {
    let newPos = this.getMousePosition(e);

    if (newPos < 0) {
      newPos = 0;
    } else if (newPos > 1) {
      newPos = 1;
    }
    this.setState({ newValue: newPos }, this.onChange);
  };

  onMouseUp = () => {
    this.cleanUp();
    this.setState({ which: null });
  };

  componentWillUnmount() {
    this.cleanUp();
  }

  cleanUp = () => {
    window.removeEventListener("mousemove", this.onMouseMove);
    window.removeEventListener("mouseup", this.onMouseUp);
  };

  onChange = () => {
    const { newValue } = this.state;
    const { min, max } = this.props;
    const total = max - min;
    const minVal = Math.floor(total * newValue + min);
    this.props.onChange({ value: minVal });
  };

  render() {
    const currentPosition = `${((this.props.value / (this.props.max - this.props.min + 1)) * 100).toFixed(2)}%`;

    return (
      <div className="rangeslider">
        <div ref={(r) => (this.track = r)} className="rangeslider-track">
          <button className="rangeslider-track-button-min" onMouseDown={(e) => this.onMouseDown(e, "newValue")} style={{ left: currentPosition }}>
            {this.props.value}
          </button>
        </div>
      </div>
    );
  }
}

SingleRangeSlider.propTypes = propTypes;

export default SingleRangeSlider;
